/* =============================================
    FB 14843
   =============================================
*/
import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import { withAuthenticationContext, useAuthentication } from 'gw-digital-auth-react';

import { TranslatorContext, IntlContext } from '@jutro/locale';
import { UserService } from 'gw-capability-ri-policy';
import styles from './RIEditProfile.module.scss';
import metadata from './RIEditProfile.metadata.json5';
import messages from './RIEditProfile.messages';
import validate from '../../util/ValidationUtil';

function RIEditProfile() {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const [formData, setFormData] = useState({});
    const [saveFormData, setSaveFormData] = useState({});
    const [pageError, setPageError] = useState({});
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        setLoadingState(true);

        UserService.getGateWayCurrentUser_RI(authHeader).then(
            (response = {}) => {
                if (!_.isUndefined(response)) {
                    setFormData(response);
                    setSaveFormData(response);
                }
            }
        ).catch((err) => {
            alert(err.error);
            switch (err.error) {
                case AUTH_ERRORS.invalidTokenOrEmail:
                    updatePageError(AUTH_ERRORS.invalidTokenOrEmail);
                    break;
                default:
                    updatePageError(AUTH_ERRORS.invalidAttempt);
                    break;
            }
        }).finally(() => {
            setLoadingState(false);
        });
    }, []);

    const enterEditMode = () => {
        setIsEditing(true);
        setPageError({});
    };

    const handleCancel = () => {
        setIsEditing(false);
        setPageError(null);
        setFormData(saveFormData);
    };

    const handleEmail = useCallback(() => {
        const error = validate(formData, 'emailAddress');
        return error;
    }, [formData]);

    const readValue = useCallback((id, path) => {
        return _.get(formData, path);
    }, [formData]);

    const writeValue = useCallback(
        (value, path) => {
            setPageError(null);
            setFormData({ ...formData, [path]: value });
        },
        [formData]
    );

    const handleSubmit = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }

            if (_.isEmpty(formData.firstName)) {
                setPageError('firstName1');
                return Promise.resolve();
            }

            if (_.isEmpty(formData.lastName)) {
                setPageError('lastName1');
                return Promise.resolve();
            }

            if (!(Object.keys(handleEmail()).length === 0) || _.isEmpty(formData.emailAddress)) {
                setPageError('invalidEmail');
                return Promise.resolve();
            }

            UserService.updateInsuredUser_RI(formData, authHeader)
                .then((data) => {
                    setPageError('successMessage');
                    setIsEditing(false);
                })
                .catch((err) => {
                    switch (err.error) {
                        case AUTH_ERRORS.invalidTokenOrEmail:
                            setPageView(AUTH_ERRORS.invalidTokenOrEmail);
                            break;
                        default:
                            setPageView(AUTH_ERRORS.invalidAttempt);
                            break;
                    }
                });
        },
        [authHeader, formData]
    );

    const overrides = {
        '@field': {
            onValueChange: writeValue
        },

        errorMsg: {
            visible: !_.isUndefined(pageError),
            content: translator(messages[pageError])
        },
        userProfileForm: {
            onSubmit: handleSubmit
        },
        saveButton: {
            onTrigger: handleSubmit,
            visible: isEditing
        },
        cancelButton: {
            visible: isEditing
        },
        emailMsg: {
            visible: !(Object.keys(handleEmail()).length === 0),
            content: handleEmail().email
        },

        firstname: {
            readOnly: !isEditing
        },
        lastname: {
            readOnly: !isEditing
        },
        email: {
            readOnly: !isEditing,
            className: !(Object.keys(handleEmail()).length === 0) ? styles.errInputFieldColor : ''
        },
        editButton: {
            visible: !isEditing
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveComponentMap: {

        },
        resolveCallbackMap: {
            enterEditMode,
            handleCancel
        },
    };

    // return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

export default withRouter(withAuthenticationContext(RIEditProfile));
